export const handleDniInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 8)
        .replace(/[^0-9]+/ig, '');
};

export const handleFullNameInput = (e) => {
    let val = e.target.value
        .slice(0, 30)
        .replace(/[^ a-záéíóúüñ]+/ig, '')
        .toLowerCase()
        .replace(/\s{2,}/g, ' ')
        .trimStart();

    val = val.split(' ').map(word => (
        word.length ? word[0].toLocaleUpperCase('es-PE') + word.slice(1) : ''
    )).join(' ');

    e.target.value = val;
};

export const handleLastNameInput = (e) => {
    let val = e.target.value
        .slice(0, 35)
        .replace(/[^ a-záéíóúüñ]+/ig, '')
        .toLowerCase()
        .replace(/\s{2,}/g, ' ')
        .trimStart();

    val = val.split(' ').map(word => (
        word.length ? word[0].toLocaleUpperCase('es-PE') + word.slice(1) : ''
    )).join(' ');

    e.target.value = val;
};

export const handlePhoneInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 9)
        .replace(/[^0-9]+/ig, '');
};

export const handleEmailInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 50)
        .replace(/[^ 0-9a-záéíóúüñ@._-]+/ig, '')
        .toLowerCase();
};

export const handleAddressInput = (e) => {
    let val = e.target.value
        .slice(0, 50)
        .replace(/[^ a-záéíóúüñ0-9.#]+/ig, '')
        .toLowerCase()
        .replace(/\s{2,}/g, ' ')
        .trimStart();

    val = val.split(' ').map(word => (
        word.length ? word[0].toLocaleUpperCase('es-PE') + word.slice(1) : ''
    )).join(' ');

    e.target.value = val;
};

export const handleImeiInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 15)
        .replace(/[^0-9]+/ig, '');
};

export const handleCoorsInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 15)
        .replace(/(?!^-)[^0-9.]/g, '')
        .replace(/^(-?\d{0,2})(\.\d{0,10})?.*$/, (_, intPart, decPart) => intPart + (decPart || ''));
};

export const handleCustomInput = (e, num) => {
    let val = e.target.value
        .slice(0, num)
        .replace(/[^ a-zA-Z0-9#áéíóúüñÁÉÍÓÚÜÑ.]+/g, '')
        .toLowerCase()
        .replace(/\s{2,}/g, ' ')
        .trimStart();

    val = val.split(' ').map(word => (
        word.length ? word[0].toLocaleUpperCase('es-PE') + word.slice(1) : ''
    )).join(' ');

    e.target.value = val;
};

export const normalizePriceValue = (value) => {
    const raw = String(value ?? "")
        .trim()
        .replace(/\s+/g, "")
        .replace(/[^\d,.-]/g, "");

    if (!raw) return "";

    const lastComma = raw.lastIndexOf(",");
    const lastDot = raw.lastIndexOf(".");
    const hasComma = lastComma !== -1;
    const hasDot = lastDot !== -1;
    let normalized = raw;

    if (hasComma && hasDot) {
        const decimalSeparator = lastComma > lastDot ? "," : ".";
        const thousandsSeparator = decimalSeparator === "," ? "." : ",";
        normalized = raw.split(thousandsSeparator).join("").replace(decimalSeparator, ".");
    } else if (hasComma || hasDot) {
        const separator = hasComma ? "," : ".";
        const index = raw.lastIndexOf(separator);
        const decimals = raw.length - index - 1;
        if (decimals === 1 || decimals === 2) normalized = raw.replace(separator, ".");
        else if (decimals === 3 && index > 0) normalized = raw.split(separator).join("");
        else normalized = raw.replace(separator, ".");
    }

    normalized = normalized.replace(/(?!^)-/g, "");
    const numeric = Number(normalized);
    if (!Number.isFinite(numeric)) return "";
    return numeric.toFixed(2);
};

export const handlePriceInput = (e) => {
    let value = e.target.value.trimStart().replace(/[^0-9]/g, '');
    if (value === '') {
        e.target.value = '';
        return;
    }
    const number = Number(value) / 100;
    const formattedValue = new Intl.NumberFormat('es-PE', {
        style: 'decimal',
        currency: 'PEN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);

    e.target.value = formattedValue;
};

export const handleTextInput = (e, num) => {
    let val = e.target.value
        .slice(0, num)
        .replace(/[^ a-záéíóúüñÁÉÍÓÚÜÑ]+/gi, '')
        .toLowerCase()
        .replace(/\s{2,}/g, ' ')
        .trimStart();

    val = val.split(' ').map(word => (
        word.length ? word[0].toLocaleUpperCase('es-PE') + word.slice(1) : ''
    )).join(' ');

    e.target.value = val;
};

export const handleNumberInput = (e, num) => {
    e.target.value = e.target.value
        .trimStart() // Elimina los espacios al inicio
        .slice(0, num) // Limita el número de caracteres
        .replace(/[^0-9]/g, ''); // Asegura que solo se permitan números, eliminando todo lo demás
};


export const handleSkuInput = (e) => {
    e.target.value = e.target.value
        .trimStart()
        .slice(0, 10)
        .replace(/[^0-9]+/ig, '');
};
